module.exports = __webpack_public_path__ + "img/newPaintingPav7m.80471d30.png";